var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { v4 } from 'uuid';
import { outputMsg } from 'store/actioin/action';
import { generateTable } from 'helpers/dataHelper';
// 处理后端回参，转格式
var uploadOldToNew = function (data, newParams) {
    var _a, _b, _c, _d, _e;
    var oldData = data;
    oldData.data.extractSeq = (newParams === null || newParams === void 0 ? void 0 : newParams.extractSeq) || sequenct;
    oldData.data.listJson = (_a = oldData.data.listJson) === null || _a === void 0 ? void 0 : _a.map(function (listJsonItem) {
        var _a;
        var seq = (_a = __spreadArray(__spreadArray([], ((newParams === null || newParams === void 0 ? void 0 : newParams.extractSeq) || []), true), ((newParams === null || newParams === void 0 ? void 0 : newParams.llmSeq) || []), true)) === null || _a === void 0 ? void 0 : _a.find(function (item) { return item.extractNum === listJsonItem.key; });
        return __assign(__assign({}, listJsonItem), { inputType: (seq === null || seq === void 0 ? void 0 : seq.fieldType) || '1' });
    });
    if (!((_b = oldData.data) === null || _b === void 0 ? void 0 : _b.tableJson)) {
        oldData.data.tableJson = [];
    }
    if (!((_c = oldData.data) === null || _c === void 0 ? void 0 : _c.tableListJson)) {
        oldData.data.tableListJson = {};
    }
    if (!((_d = oldData.data) === null || _d === void 0 ? void 0 : _d.llmTableJson)) {
        oldData.data.llmTableJson = [];
    }
    if (!((_e = oldData.data) === null || _e === void 0 ? void 0 : _e.llmTableListJson)) {
        oldData.data.llmTableListJson = {};
    }
    return oldData;
};
export function dataConversion(data, store) {
    var dispatch = store.dispatch;
    var keyList = Object.keys(data);
    console.log('++util++', '\n', 'data:', data, '\n', 'store:', store);
    keyList.forEach(function (key) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        switch (key) {
            case 'init':
                switch (data[key].viewType) {
                    case 'ie_test_task':
                        dispatch({
                            type: 'changeControl',
                            payload: {
                                activeView: 'homepage',
                                operate: 'create_extract',
                                controlDisplay: false,
                                attachmentUpload: false,
                            },
                        });
                        break;
                    case 'ie_create_task':
                        dispatch({
                            type: 'changeControl',
                            payload: {
                                activeView: 'homepage',
                                operate: 'create_extract',
                                controlDisplay: true,
                                attachmentUpload: true,
                            },
                        });
                        if (data[key].initAttData &&
                            Object.keys(data[key].initAttData).length > 0) {
                            if (data[key].initAttData.fileSize < 50 * 1024 * 1024) {
                                dispatch({
                                    type: 'changeMainPageFile',
                                    payload: {
                                        name: data[key].initAttData.fileName,
                                        type: data[key].initAttData.fileType,
                                        hasData: true,
                                        url: data[key].initAttData.url,
                                        status: 'success',
                                        tempFileId: data[key].initAttData.tempFileId
                                            ? data[key].initAttData.tempFileId
                                            : '',
                                    },
                                });
                            }
                        }
                        break;
                    case 'ie_show_task':
                        dispatch({
                            type: 'changeControl',
                            payload: {
                                activeView: 'displaypage',
                                operate: 'create_extract',
                                controlDisplay: false,
                                attachmentUpload: false,
                            },
                        });
                        dispatch({
                            type: 'changeDisplayPageFile',
                            payload: {
                                name: data[key].showData.fileData.fileName,
                                type: data[key].showData.fileData.fileName
                                    .slice(data[key].showData.fileData.fileName.lastIndexOf('.') + 1)
                                    .toLowerCase(),
                            },
                        });
                        dataConversion({
                            ie_show_task: {
                                extractData: data[key].showData.extractData,
                                taskId: data[key].showData.extractData.taskId,
                                status: data[key].showData.extractData.status,
                                progress: data[key].showData.extractData.progress,
                            },
                        }, store);
                        break;
                }
                dispatch({
                    type: 'changeGlobal',
                    payload: {
                        serverUrl: data[key].url,
                        billId: data[key].billid,
                        viewType: data[key].viewType,
                        planList: data[key].planList,
                    },
                });
                break;
            case 'startExtract':
                if (!(data[key] === 'validFileError') &&
                    !(data[key] === 'validLicenseError') &&
                    !(data[key] === 'systemError')) {
                    dispatch({
                        type: 'startExtract',
                        payload: {
                            data: {
                                taskId: data[key],
                                status: "loading",
                            },
                            control: { activeView: 'displaypage' },
                        },
                    });
                    dispatch({
                        type: 'invokePolling',
                        payload: data[key],
                    });
                }
                else {
                    dispatch({ type: 'backHomePage', payload: 'backHomePage' });
                }
                break;
            case 'ie_show_task':
                switch (data[key].status) {
                    case 'loading':
                        dispatch({
                            type: 'startExtract',
                            payload: {
                                data: {
                                    taskId: data[key].taskId,
                                    status: 'loading',
                                },
                                control: { activeView: 'displaypage' },
                            },
                        });
                        dispatch({
                            type: 'invokePolling',
                            payload: data[key].taskId,
                        });
                        break;
                    case 'running':
                        dispatch({
                            type: 'startExtract',
                            payload: {
                                data: {
                                    taskId: data[key].taskId,
                                    status: 'loading',
                                },
                                control: { activeView: 'displaypage' },
                            },
                        });
                        dispatch({
                            type: 'invokePolling',
                            payload: data[key].taskId,
                        });
                        break;
                    case 'error':
                        // dispatch({
                        //     type: "outputMsg",
                        //     payload: data[key].progress,
                        // })
                        dispatch({
                            type: 'showErrorResult',
                            payload: {
                                data: {
                                    taskId: data[key].taskId,
                                    status: data[key].status,
                                    traceId: data[key].traceId || data[key].extractData.traceId,
                                    progress: data[key].progress,
                                },
                                control: { activeView: 'displaypage' },
                            },
                        });
                        break;
                    case 'success':
                        timer.destory();
                        if (((_b = (_a = data[key]) === null || _a === void 0 ? void 0 : _a.extractData) === null || _b === void 0 ? void 0 : _b.isUpdate) &&
                            ((_d = (_c = data[key]) === null || _c === void 0 ? void 0 : _c.extractData) === null || _d === void 0 ? void 0 : _d.updateData)) {
                            console.log('!!!!', data);
                            dispatch({
                                type: 'changeExtractData',
                                payload: __assign(__assign({}, uploadOldToNew(
                                // TODO
                                JSON.parse((_f = (_e = data[key]) === null || _e === void 0 ? void 0 : _e.extractData) === null || _f === void 0 ? void 0 : _f.updateData), data[key].extractData)), { wordSelection: {
                                        show: false,
                                        showOptionList: false,
                                        pageNum: null,
                                        words: '',
                                        wordsShapeId: [],
                                        activeShapeId: '',
                                        field: '',
                                    } }),
                            });
                        }
                        else {
                            if (data[key].extractData.isNew) {
                                var normalInfoData = data[key].extractData.tieInfo;
                                var extractSeq = data[key].extractData.extractSeq
                                    ? data[key].extractData.extractSeq
                                    : sequenct;
                                var tableInfo = data[key].extractData.tieTableInfo;
                                var returnJson = constructUsefulData(normalInfoData, extractSeq);
                                var tableJson = [];
                                var tableListJson = {};
                                if (tableInfo) {
                                    var _j = generateTable(tableInfo, extractSeq), tableData = _j.tableData, tableShapeData = _j.tableShapeData;
                                    tableJson = tableShapeData;
                                    tableListJson = tableData;
                                }
                                // 大模型
                                var _k = data[key].extractData, _l = _k.llmSeq, llmSeq = _l === void 0 ? [] : _l, _m = _k.llmInfo, llmInfo = _m === void 0 ? {} : _m, _o = _k.llmTableInfo, llmTableInfo = _o === void 0 ? {} : _o;
                                var llmReturnJson = constructUsefulData(llmInfo, llmSeq, true);
                                var llmTableJson = [];
                                var llmTableListJson = {};
                                if (llmTableInfo) {
                                    var _p = generateTable(llmTableInfo, llmSeq), tableData = _p.tableData, tableShapeData = _p.tableShapeData;
                                    llmTableJson = tableShapeData;
                                    llmTableListJson = tableData;
                                }
                                dispatch({
                                    type: 'showSuccessfulResult',
                                    payload: {
                                        data: {
                                            taskId: data[key].taskId,
                                            status: data[key].status,
                                            data: __assign(__assign({}, data[key].extractData), { calcuJson: returnJson.calcuJson.concat(llmReturnJson.calcuJson), listJson: returnJson.listJson.concat(llmReturnJson.listJson), tableJson: tableJson, tableListJson: tableListJson, extractSeq: data[key].extractData.extractSeq
                                                    ? data[key].extractData.extractSeq
                                                    : sequenct, drawJson: [], llmSeq: llmSeq, llmInfo: llmInfo, llmTableInfo: llmTableInfo, llmTableJson: llmTableJson, llmTableListJson: llmTableListJson }),
                                        },
                                        control: { activeView: 'displaypage' },
                                    },
                                });
                            }
                            else {
                                var returnJson = cloneCalcuPosition(data[key].extractData.tieDocContents, data[key].extractData.tieInfo, data[key].extractData.extractSeq
                                    ? data[key].extractData.extractSeq
                                    : sequenct);
                                var tableJson = [];
                                var tableListJson = {};
                                dispatch({
                                    type: 'showSuccessfulResult',
                                    payload: {
                                        data: {
                                            taskId: data[key].taskId,
                                            status: data[key].status,
                                            data: __assign(__assign({}, data[key].extractData), { extractSeq: data[key].extractData.extractSeq
                                                    ? data[key].extractData.extractSeq
                                                    : sequenct, calcuJson: returnJson.calcuJson, listJson: returnJson.listJson, tableJson: tableJson, tableListJson: tableListJson, drawJson: [] }),
                                        },
                                        control: { activeView: 'displaypage' },
                                    },
                                });
                            }
                        }
                        break;
                    default:
                }
                break;
            case 'polling':
                switch (data[key].status) {
                    case 'running':
                        dispatch({
                            type: 'invokePolling',
                            payload: data[key].taskId,
                        });
                        if (data[key].progress) {
                            dispatch({
                                type: 'updateProgress',
                                payload: data[key].progress,
                            });
                        }
                        return;
                    case 'loading':
                        dispatch({
                            type: 'invokePolling',
                            payload: data[key].taskId,
                        });
                        if (data[key].progress) {
                            dispatch({
                                type: 'updateProgress',
                                payload: data[key].progress,
                            });
                        }
                        return;
                    case 'error':
                        timer.destory();
                        // dispatch({
                        //     type: "outputMsg",
                        //     payload: data[key].progress,
                        // })
                        dispatch({
                            type: 'showErrorResult',
                            payload: {
                                data: {
                                    taskId: data[key].taskId,
                                    status: data[key].status,
                                    traceId: data[key].traceId || data[key].extractData.traceId,
                                    progress: data[key].progress,
                                },
                                control: { activeView: 'displaypage' },
                            },
                        });
                        return;
                    case 'success':
                        timer.destory();
                        if (data[key].extractData.isNew) {
                            var normalInfoData = data[key].extractData.tieInfo;
                            var extractSeq = data[key].extractData.extractSeq
                                ? data[key].extractData.extractSeq
                                : sequenct;
                            var tableInfo = data[key].extractData.tieTableInfo;
                            var returnJson = constructUsefulData(normalInfoData, extractSeq);
                            var tableJson = [];
                            var tableListJson = {};
                            if (tableInfo) {
                                var _q = generateTable(tableInfo, extractSeq), tableData = _q.tableData, tableShapeData = _q.tableShapeData;
                                tableJson = tableShapeData;
                                tableListJson = tableData;
                            }
                            // 大模型
                            var _r = data[key].extractData, _s = _r.llmSeq, llmSeq = _s === void 0 ? [] : _s, _t = _r.llmInfo, llmInfo = _t === void 0 ? {} : _t, _u = _r.llmTableInfo, llmTableInfo = _u === void 0 ? {} : _u;
                            var llmReturnJson = constructUsefulData(llmInfo, llmSeq, true);
                            var llmTableJson = [];
                            var llmTableListJson = {};
                            if (llmTableInfo) {
                                var _v = generateTable(llmTableInfo, llmSeq), tableData = _v.tableData, tableShapeData = _v.tableShapeData;
                                llmTableJson = tableShapeData;
                                llmTableListJson = tableData;
                            }
                            dispatch({
                                type: 'showSuccessfulResult',
                                payload: {
                                    data: {
                                        taskId: data[key].taskId,
                                        status: data[key].status,
                                        data: __assign(__assign({}, data[key].extractData), { calcuJson: returnJson.calcuJson.concat(llmReturnJson.calcuJson), listJson: returnJson.listJson.concat(llmReturnJson.listJson), tableJson: tableJson, tableListJson: tableListJson, extractSeq: data[key].extractData.extractSeq
                                                ? data[key].extractData.extractSeq
                                                : sequenct, drawJson: [], llmSeq: llmSeq, llmInfo: llmInfo, llmTableInfo: llmTableInfo, llmTableJson: llmTableJson, llmTableListJson: llmTableListJson }),
                                    },
                                    control: { activeView: 'displaypage' },
                                },
                            });
                        }
                        else {
                            var returnJson = cloneCalcuPosition(data[key].extractData.tieDocContents, data[key].extractData.tieInfo, data[key].extractData.extractSeq
                                ? data[key].extractData.extractSeq
                                : sequenct);
                            dispatch({
                                type: 'showSuccessfulResult',
                                payload: {
                                    data: {
                                        taskId: data[key].taskId,
                                        status: data[key].status,
                                        data: __assign(__assign({}, data[key].extractData), { calcuJson: returnJson.calcuJson, listJson: returnJson.listJson, extractSeq: data[key].extractData.extractSeq
                                                ? data[key].extractData.extractSeq
                                                : sequenct, drawJson: [] }),
                                    },
                                    control: { activeView: 'displaypage' },
                                },
                            });
                        }
                        return;
                    default:
                }
                break;
            case 'recognize':
                dispatch({ type: 'responseData', payload: data[key] });
                break;
            case 'displayHistoryData':
                dispatch({
                    type: 'changeControl',
                    payload: { activeView: 'displaypage' },
                });
                dispatch({ type: 'changeExtractData', payload: data[key] });
                break;
            case 'getAttachmentList':
                dispatch({ type: 'changeAttachmentList', payload: data[key] });
                break;
            case 'ie_history_task':
                dispatch({ type: 'changeHistoryList', payload: data[key] });
                break;
            case 'ie_delhistory_task':
                if (data[key].status === true && data[key].code === 0) {
                    dispatch({
                        type: 'doDeleteHistorical',
                        payload: 'doDeleteHistorical',
                    });
                }
                else {
                    // error报错
                    dispatch(outputMsg(data[key].errorMsg));
                }
                break;
            case 'showF7':
                if (JSON.parse(data[key]).type === 'currency') {
                    dispatch({ type: 'changeSelectId', payload: '' });
                    dispatch({
                        type: 'changeF7Currency',
                        payload: {
                            value: JSON.parse(data[key]).value,
                            drawData: [],
                            select: null,
                            selectType: 'input',
                            key: 'currency',
                            confidence: null,
                        },
                    });
                }
                break;
            case 'validExtractFile':
                if (data[key].validResult) {
                    dispatch({
                        type: 'changeMainPageFile',
                        payload: {
                            status: 'success',
                            tempFileId: data[key].tempFileId,
                        },
                    });
                }
                else {
                    dispatch({
                        type: 'changeMainPageFile',
                        payload: {
                            status: 'error',
                            tempFileId: '',
                        },
                    });
                }
                break;
            case 'cancelExtract':
                // 列表中取消任务后重新获取历史列表
                if (((_h = (_g = store.getState()) === null || _g === void 0 ? void 0 : _g.control) === null || _h === void 0 ? void 0 : _h.operate) === 'history_extract') {
                    dispatch({
                        type: 'getHistoryList',
                    });
                }
                break;
            default:
        }
    });
}
// timeStamp 转换年月日时分秒
export var toYMDHMS = function (inputTime) {
    var date = new Date(inputTime);
    var y = date.getFullYear();
    var m = date.getMonth() + 1;
    m = m < 10 ? "0".concat(m) : m;
    var d = date.getDate();
    d = d < 10 ? "0".concat(d) : d;
    var h = date.getHours();
    h = h < 10 ? "0".concat(h) : h;
    var minute = date.getMinutes();
    var second = date.getSeconds();
    minute = minute < 10 ? "0".concat(minute) : minute;
    second = second < 10 ? "0".concat(second) : second;
    return "".concat(y, "-").concat(m, "-").concat(d, " ").concat(h, ":").concat(minute, ":").concat(second);
};
// 校验承诺的文件类型
export var promiseType = {
    pdf: true,
    wps: true,
    WPS: true,
    jpg: true,
    jpeg: true,
    png: true,
    bmp: true,
    tif: false,
    tiff: false,
    doc: true,
    docx: true,
    ofd: true,
};
// 检测对象中是否存在key
export function isValidKey(key, object) {
    return key in object;
}
// request封装
export function request(url, options, callback) {
    var newOptions = __assign({}, options);
    if (newOptions.method === 'POST' || newOptions.method === 'PUT') {
        newOptions.headers = {
            Accept: 'application/json',
            ContentType: 'application/json',
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': 'Origin, X-Requested-With, Content-Type, Accept',
            'Access-Control-Allow-Methods': 'PUT,POST,GET,DELETE,OPTIONS',
            // ...newOptions.headers,
        };
    }
    fetch(url, newOptions)
        .then(function (response) {
        return response.json();
    })
        .then(function (data) {
        if (callback) {
            callback(data);
        }
    });
}
export function rewriteData(data) {
    var rewriteIimgList = data.imgList.map(function (item) {
        if ('imageBase64' in item &&
            item.imageBase64 !== null &&
            item.imageBase64 !== undefined) {
            return {
                imgSrc: "data:image/png;base64,".concat(item.imageBase64),
            };
        }
    });
    return {
        imgList: rewriteIimgList,
    };
}
// 轮询 timer类
var Timer = /** @class */ (function () {
    function Timer() {
        var _this = this;
        this.setTaskId = function (taskId) {
            _this.taskId = taskId;
        };
        this.invokePolling = function (cb) {
            if (_this.timeOut) {
                clearTimeout(_this.timeOut);
            }
            _this.timeOut = setTimeout(function () { return cb(); }, 2000);
        };
        this.destory = function () {
            _this.taskId = null;
            clearTimeout(_this.timeOut);
        };
        this.taskId = null;
        this.timeOut = null;
    }
    return Timer;
}());
export default Timer;
// 轮询初始化timer
export var timer = new Timer();
// 对算法返回info与content处理拆分出提取字段位置
function calcuPosition(docContent, info) {
    var calcuJson = [];
    var listJson = [];
    var strList = [];
    var wordsCount = 0;
    docContent.forEach(function (item) {
        var pageLayouts = item.pageLayouts, pageNum = item.pageNum;
        pageLayouts.forEach(function (pageLayout) {
            var texts = pageLayout.texts;
            strList = strList.concat(texts.map(function (text) {
                return {
                    words: text.words,
                    wordsIdx: text.wordsIdx,
                    wordsLocation: text.wordsLocation,
                    pageNum: pageNum,
                    wordsLength: text.words.length,
                    spaceNum: text.words.split(' ').length - 1,
                    include: false,
                    includeType: '',
                    infoText: '',
                    confidence: 1,
                    rightCut: 0,
                    leftCut: 0,
                    type: 'calcuJson',
                };
            }));
        });
    });
    // todo
    sequenct.forEach(function (seq) {
        listJson.push({
            key: seq.extractNum,
            data: [],
            drawData: [],
            inputType: seq.fieldType ? seq.fieldType : '1',
            value: '',
            select: null,
            selectType: null,
            confidence: null,
        });
        info[seq.extractNum].forEach(function (jsonItem) {
            var extractId = v4();
            for (var i = 0; i < jsonItem.index.length; i++) {
                wordsCount = 0;
                for (var j = 0; j < strList.length; j++) {
                    // 起点： wordsCount + 1 终点： wordsCount+strList[j].wordsLength-spaceNum
                    var A = jsonItem.index[i][0] + 1; // 提取信息起点index
                    var B = jsonItem.index[i][1]; // 提取信息终点index
                    var C = wordsCount + 1; // 当前查找位置
                    var D = wordsCount + strList[j].wordsLength - strList[j].spaceNum; // 单行或某段截止位置
                    if (A <= C && B >= C && B <= D) {
                        var newItem = __assign({}, strList[j]);
                        newItem.extractId = extractId;
                        newItem.include = true;
                        newItem.includeType = 'left';
                        newItem.infoText = jsonItem.text;
                        newItem.confidence = jsonItem.confidence;
                        // newItem.rightCut = D - B
                        newItem.rightCut =
                            D -
                                B -
                                newItem.words
                                    .slice(newItem.wordsLength - (D - B), newItem.wordsLength)
                                    .replace(/\D/g, '').length *
                                    0.5;
                        newItem.cutLength =
                            newItem.wordsLength -
                                newItem.words
                                    .slice(newItem.wordsLength - (D - B), newItem.wordsLength)
                                    .replace(/\D/g, '').length *
                                    0.5;
                        newItem.oldLocation = newItem.wordsLocation;
                        newItem.wordsLocation = cutPosition(0, newItem.rightCut / newItem.cutLength, newItem.wordsLocation);
                        newItem.key = seq.extractNum;
                        calcuJson.push(__assign(__assign({}, newItem), { shapeId: v4() }));
                    }
                    else if (A <= D && B >= D && A >= C) {
                        var newItem = __assign({}, strList[j]);
                        newItem.extractId = extractId;
                        newItem.include = true;
                        newItem.includeType = 'right';
                        newItem.infoText = jsonItem.text;
                        newItem.confidence = jsonItem.confidence;
                        // newItem.leftCut = A - C
                        newItem.leftCut =
                            A -
                                C -
                                newItem.words.slice(0, A - C).replace(/\D/g, '').length * 0.5;
                        newItem.cutLength =
                            newItem.wordsLength -
                                newItem.words.slice(0, A - C).replace(/\D/g, '').length * 0.5;
                        newItem.oldLocation = newItem.wordsLocation;
                        newItem.wordsLocation = cutPosition(newItem.leftCut / newItem.cutLength, 0, newItem.wordsLocation);
                        newItem.key = seq.extractNum;
                        calcuJson.push(__assign(__assign({}, newItem), { shapeId: v4() }));
                    }
                    else if (A >= C && B <= D) {
                        var newItem = __assign({}, strList[j]);
                        newItem.extractId = extractId;
                        newItem.include = true;
                        newItem.includeType = 'middle';
                        newItem.infoText = jsonItem.text;
                        newItem.confidence = jsonItem.confidence;
                        // newItem.leftCut = A - C
                        // newItem.rightCut = D - B
                        newItem.leftCut =
                            A -
                                C -
                                newItem.words.slice(0, A - C).replace(/\D/g, '').length * 0.5;
                        newItem.rightCut =
                            D -
                                B -
                                newItem.words
                                    .slice(newItem.wordsLength - (D - B), newItem.wordsLength)
                                    .replace(/\D/g, '').length *
                                    0.5;
                        newItem.cutLength =
                            newItem.wordsLength -
                                (newItem.words.slice(0, A - C).replace(/\D/g, '').length * 0.5 +
                                    newItem.words
                                        .slice(newItem.wordsLength - (D - B), newItem.wordsLength)
                                        .replace(/\D/g, '').length *
                                        0.5);
                        newItem.oldLocation = newItem.wordsLocation;
                        newItem.wordsLocation = cutPosition(newItem.leftCut / newItem.cutLength, newItem.rightCut / newItem.cutLength, newItem.wordsLocation);
                        newItem.key = seq.extractNum;
                        calcuJson.push(__assign(__assign({}, newItem), { shapeId: v4() }));
                    }
                    if (C > B) {
                        break;
                    }
                    wordsCount =
                        wordsCount + strList[j].wordsLength - strList[j].spaceNum;
                }
            }
        });
    });
    calcuJson.forEach(function (item) {
        var listItem = listJson[listJson.findIndex(function (listUnit) { return listUnit.key === item.key; })];
        if (!listItem.data.some(function (listItemData) { return listItemData.extractId === item.extractId; })) {
            listItem.data.push({
                confidence: item.confidence,
                extractId: item.extractId,
                infoText: item.infoText,
                type: item.type,
            });
        }
    });
    listJson = listJson
        // .filter((item) => item.data.length !== 0)
        .map(function (item) {
        if (item.data.length !== 0) {
            return __assign(__assign({}, item), { value: item.data[0].infoText, select: item.data[0].extractId, selectType: item.data[0].type, confidence: item.data[0].confidence });
        }
        else {
            return item;
        }
    });
    return { calcuJson: calcuJson, listJson: listJson };
}
// 切分完整行坐标
export function cutPosition(LP, RP, positioin) {
    var LTX = positioin.leftTop.x;
    var RTX = positioin.rightTop.x;
    var LTY = positioin.leftTop.y;
    var RTY = positioin.rightTop.y;
    var LBX = positioin.leftBottom.x;
    var RBX = positioin.rightBottom.x;
    var LBY = positioin.leftBottom.y;
    var RBY = positioin.rightBottom.y;
    // TODO
    return {
        leftTop: {
            x: Math.abs(LTX - RTX) * LP + Math.min(LTX, RTX) === Math.min(LTX, RTX)
                ? LTX
                : Math.abs(LTX - RTX) * LP + Math.min(LTX, RTX),
            y: Math.abs(LTY - RTY) * LP + Math.min(LTY, RTY) === Math.min(LTY, RTY)
                ? LTY
                : Math.abs(LTY - RTY) * LP + Math.min(LTY, RTY),
        },
        rightBottom: {
            x: Math.abs(LBX - RBX) * (1 - RP) + Math.min(LBX, RBX) ===
                Math.min(LBX, RBX)
                ? RBX
                : Math.abs(LBX - RBX) * (1 - RP) + Math.min(LBX, RBX),
            y: Math.abs(LBY - RBY) * (1 - RP) + Math.min(LBY, RBY) ===
                Math.min(LBY, RBY)
                ? RBY
                : Math.abs(LBY - RBY) * (1 - RP) + Math.min(LBY, RBY),
        },
        leftBottom: {
            x: Math.abs(LBX - RBX) * LP + Math.min(LBX, RBX) === Math.min(LBX, RBX)
                ? LBX
                : Math.abs(LBX - RBX) * LP + Math.min(LBX, RBX),
            y: Math.abs(LBY - RBY) * LP + Math.min(LBY, RBY) === Math.min(LBY, RBY)
                ? LBY
                : Math.abs(LBY - RBY) * LP + Math.min(LBY, RBY),
        },
        rightTop: {
            x: Math.abs(LTX - RTX) * (1 - RP) + Math.min(LTX, RTX) ===
                Math.min(LTX, RTX)
                ? RTX
                : Math.abs(LTX - RTX) * (1 - RP) + Math.min(LTX, RTX),
            y: Math.abs(LTY - RTY) * (1 - RP) + Math.min(LTY, RTY) ===
                Math.min(LTY, RTY)
                ? RTY
                : Math.abs(LTY - RTY) * (1 - RP) + Math.min(LTY, RTY),
        },
    };
}
// 字段展示序列 // TODO: 置空，数据让后端传递过来
var sequenct = [];
// const sequenct = [
//   {
//     extractFieldName: '项目编号',
//     extractNum: 'project_num',
//     fieldType: '1',
//     typeName: '通用文本',
//   },
//   {
//     extractFieldName: '合同编号',
//     extractNum: 'contract_num',
//     fieldType: '1',
//     typeName: '通用文本',
//   },
//   {
//     extractFieldName: '合同名称',
//     extractNum: 'contract_name',
//     fieldType: '1',
//     typeName: '通用文本',
//   },
//   {
//     extractFieldName: '甲方',
//     extractNum: 'part_a',
//     fieldType: '1',
//     typeName: '通用文本',
//   },
//   {
//     extractFieldName: '乙方',
//     extractNum: 'part_b',
//     fieldType: '1',
//     typeName: '通用文本',
//   },
//   {
//     extractFieldName: '甲方账号',
//     extractNum: 'part_a_account_num',
//     fieldType: '2',
//     typeName: '纯数字',
//   },
//   {
//     extractFieldName: '乙方账号',
//     extractNum: 'part_b_account_num',
//     fieldType: '2',
//     typeName: '纯数字',
//   },
//   {
//     extractFieldName: '甲方账户名称',
//     extractNum: 'part_a_account',
//     fieldType: '6',
//     typeName: '公司名称',
//   },
//   {
//     extractFieldName: '乙方账户名称',
//     extractNum: 'part_b_account',
//     fieldType: '6',
//     typeName: '公司名称',
//   },
//   {
//     extractFieldName: '甲方开户行',
//     extractNum: 'part_a_bank',
//     fieldType: '8',
//     typeName: '银行',
//   },
//   {
//     extractFieldName: '乙方开户行',
//     extractNum: 'part_b_bank',
//     fieldType: '8',
//     typeName: '银行',
//   },
//   {
//     extractFieldName: '甲方地址',
//     extractNum: 'part_a_address',
//     fieldType: '9',
//     typeName: '地址',
//   },
//   {
//     extractFieldName: '乙方地址',
//     extractNum: 'part_b_address',
//     fieldType: '9',
//     typeName: '地址',
//   },
//   {
//     extractFieldName: '甲方纳税人识别号',
//     extractNum: 'part_a_uscc',
//     fieldType: '10',
//     typeName: '数字/英文',
//   },
//   {
//     extractFieldName: '乙方纳税人识别号',
//     extractNum: 'part_b_uscc',
//     fieldType: '10',
//     typeName: '数字/英文',
//   },
//   {
//     extractFieldName: '甲方联系人',
//     extractNum: 'part_a_contacts',
//     fieldType: '7',
//     typeName: '姓名',
//   },
//   {
//     extractFieldName: '乙方联系人',
//     extractNum: 'part_b_contacts',
//     fieldType: '7',
//     typeName: '姓名',
//   },
//   {
//     extractFieldName: '甲方电话',
//     extractNum: 'part_a_phone',
//     fieldType: '13',
//     typeName: '电话号码',
//   },
//   {
//     extractFieldName: '乙方电话',
//     extractNum: 'part_b_phone',
//     fieldType: '13',
//     typeName: '电话号码',
//   },
//   {
//     extractFieldName: '甲方传真',
//     extractNum: 'part_a_fax',
//     fieldType: '13',
//     typeName: '电话号码',
//   },
//   {
//     extractFieldName: '乙方传真',
//     extractNum: 'part_b_fax',
//     fieldType: '13',
//     typeName: '电话号码',
//   },
//   {
//     extractFieldName: '甲方邮箱',
//     extractNum: 'part_a_email',
//     fieldType: '3',
//     typeName: '邮箱',
//   },
//   {
//     extractFieldName: '乙方邮箱',
//     extractNum: 'part_b_email',
//     fieldType: '3',
//     typeName: '邮箱',
//   },
//   {
//     extractFieldName: '合同金额（小写）',
//     extractNum: 'amount',
//     fieldType: '4',
//     typeName: '小写金额',
//   },
//   {
//     extractFieldName: '合同金额（大写）',
//     extractNum: 'amount_capital',
//     fieldType: '5',
//     typeName: '大写金额',
//   },
//   {
//     extractFieldName: '合同税额',
//     extractNum: 'tax_amount',
//     fieldType: '4',
//     typeName: '小写金额',
//   },
//   {
//     extractFieldName: '税率',
//     extractNum: 'tax_rate',
//     fieldType: '2',
//     typeName: '纯数字',
//   },
//   {
//     extractFieldName: '币种',
//     extractNum: 'currency',
//     fieldType: '12',
//     typeName: '币种',
//   },
//   {
//     extractFieldName: '合同签约日期',
//     extractNum: 'signing_date',
//     fieldType: '11',
//     typeName: '日期',
//   },
//   {
//     extractFieldName: '交货日期',
//     extractNum: 'delivery_date',
//     fieldType: '1',
//     typeName: '通用文本',
//   },
//   {
//     extractFieldName: '交货地点',
//     extractNum: 'place_of_delivery',
//     fieldType: '9',
//     typeName: '地址',
//   },
// ];
// inputTypeRules
export var inputTypeRules = {
    // 通用文本	1
    // 纯数字	2
    // 邮箱	3
    // 小写金额	4
    // 大写金额	5
    // 公司名称	6
    // 姓名	7
    // 银行	8
    // 地址	9
    // 数字/英文	10
    // 日期	11
    // 币种	12
    // 电话号码	13
    // 百分数 14
    '1': { placeholder: '', rule: /^/ },
    // "2": {placeholder: "", rule: /^[0-9.]*$/},
    '2': { placeholder: '', rule: /^[0-9]+(\.{0,1})([0-9]+)?$/ },
    '3': {
        placeholder: '',
        // rule: /^[a-zA-Z0-9._-]((?![\.|\_|\-]{2})[\w!._-])*(?<![.])@([a-zA-Z0-9]+\.[a-zA-Z0-9]+)+$/,
        rule: /^\w+([\._\\-]*\w)*@(\w+[\w|\-]*\.){1,63}[\w|\-]+$/,
    },
    '4': { placeholder: '', rule: /^[0-9]+(\.{0,1})([0-9]+)?$/ },
    '5': { placeholder: '', rule: /^[\u4E00-\u9FA5]+$/ },
    '6': { placeholder: '', rule: /^/ },
    '7': { placeholder: '', rule: /^[\u4E00-\u9FA5a-zA-Z·,.-]+$/ },
    '8': { placeholder: '', rule: /^/ },
    '9': { placeholder: '', rule: /^/ },
    '10': { placeholder: '', rule: /^[a-zA-Z0-9]+$/ },
    '11': {
        placeholder: 'YYYY-MM-DD',
        rule: /^\d{4}\-(0?[1-9]|1[012])\-(0?[1-9]|[12][0-9]|3[01])$/,
    },
    '12': { placeholder: '', rule: /^/ },
    '13': { placeholder: '', rule: /^/ },
    '14': { placeholder: '', rule: /^(100|[1-9]?\d(\.\d+)?)%$/ },
};
// 对算法返回info与content处理拆分出提取字段位置
function cloneCalcuPosition(docContent, info, sequenct) {
    var cloneInfo = Object.assign(info);
    for (var key in cloneInfo) {
        cloneInfo[key] = cloneInfo[key].map(function (item) {
            return __assign(__assign({}, item), { extractId: v4() });
        });
    }
    var beforCalcuJson = [];
    var calcuJson = [];
    var listJson = [];
    var wordsCount = 0;
    docContent.forEach(function (item) {
        var pageLayouts = item.pageLayouts, pageNum = item.pageNum;
        pageLayouts.forEach(function (pageLayout) {
            var texts = pageLayout.texts;
            texts.forEach(function (text) {
                var C = wordsCount + 1; // 当前查找位置
                var D = wordsCount + text.words.length - text.words.split(' ').length + 1; // 单行或某段截止位置
                var _loop_1 = function (key) {
                    cloneInfo[key].forEach(function (jsonItem) {
                        for (var i = 0; i < jsonItem.index.length; i++) {
                            var A = jsonItem.index[i][0] + 1; // 提取信息起点index
                            var B = jsonItem.index[i][1]; // 提取信息终点index
                            var item_1 = {
                                words: text.words,
                                wordsIdx: text.wordsIdx,
                                pageNum: pageNum,
                                wordsLength: text.words.length,
                                spaceNum: text.words.split(' ').length - 1,
                                include: true,
                                includeType: 'left',
                                infoText: jsonItem.text,
                                confidence: jsonItem.confidence,
                                oldLocation: text.wordsLocation,
                                key: key,
                                type: 'calcuJson',
                                shapeId: v4(),
                                extractId: jsonItem.extractId,
                            };
                            // 起点： wordsCount + 1 终点： wordsCount+strList[j].wordsLength-spaceNum
                            if (A <= C && B >= C && B <= D) {
                                item_1.rightCut =
                                    D -
                                        B -
                                        text.words
                                            .slice(text.words.length - (D - B), text.words.length)
                                            .replace(/\D/g, '').length *
                                            0.5;
                                item_1.leftCut = 0;
                                item_1.cutLength =
                                    text.words.length -
                                        text.words
                                            .slice(text.words.length - (D - B), text.words.length)
                                            .replace(/\D/g, '').length *
                                            0.5;
                                beforCalcuJson.push(__assign(__assign({}, item_1), { wordsLocation: cutPosition(0, item_1.rightCut / item_1.cutLength, item_1.oldLocation) }));
                            }
                            else if (A <= D && B >= D && A >= C) {
                                item_1.rightCut = 0;
                                item_1.leftCut =
                                    A -
                                        C -
                                        text.words.slice(0, A - C).replace(/\D/g, '').length * 0.5;
                                item_1.cutLength =
                                    text.words.length -
                                        text.words.slice(0, A - C).replace(/\D/g, '').length * 0.5;
                                beforCalcuJson.push(__assign(__assign({}, item_1), { wordsLocation: cutPosition(0, item_1.rightCut / item_1.cutLength, item_1.oldLocation) }));
                            }
                            else if (A >= C && B <= D) {
                                item_1.rightCut =
                                    D -
                                        B -
                                        text.words
                                            .slice(text.words.length - (D - B), text.words.length)
                                            .replace(/\D/g, '').length *
                                            0.5;
                                item_1.leftCut =
                                    A -
                                        C -
                                        text.words.slice(0, A - C).replace(/\D/g, '').length * 0.5;
                                item_1.cutLength =
                                    text.words.length -
                                        (text.words.slice(0, A - C).replace(/\D/g, '').length * 0.5 +
                                            text.words
                                                .slice(text.words.length - (D - B), text.words.length)
                                                .replace(/\D/g, '').length *
                                                0.5);
                                beforCalcuJson.push(__assign(__assign({}, item_1), { wordsLocation: cutPosition(0, item_1.rightCut / item_1.cutLength, item_1.oldLocation) }));
                            }
                            if (C > B) {
                                break;
                            }
                        }
                    });
                };
                for (var key in cloneInfo) {
                    _loop_1(key);
                }
                wordsCount =
                    wordsCount + text.words.length - text.words.split(' ').length + 1;
            });
        });
    });
    // todo
    sequenct.forEach(function (seq) {
        listJson.push({
            key: seq.extractNum,
            data: [],
            drawData: [],
            value: '',
            inputType: seq.fieldType ? seq.fieldType : '1',
            select: null,
            selectType: null,
            confidence: null,
        });
        calcuJson = calcuJson.concat(beforCalcuJson
            .filter(function (item) { return item.key === seq.extractNum; })
            .map(function (calcuItem) {
            var listItem = listJson[listJson.findIndex(function (listUnit) { return listUnit.key === calcuItem.key; })];
            if (!listItem.data.some(function (listItemData) { return listItemData.extractId === calcuItem.extractId; })) {
                listItem.data.push({
                    confidence: calcuItem.confidence,
                    extractId: calcuItem.extractId,
                    infoText: calcuItem.infoText,
                    type: calcuItem.type,
                });
            }
            return __assign({}, calcuItem);
        }));
    });
    listJson = listJson.map(function (item) {
        if (item.data.length !== 0) {
            return __assign(__assign({}, item), { value: item.data[0].infoText, select: item.data[0].extractId, selectType: item.data[0].type, confidence: item.data[0].confidence });
        }
        else {
            return item;
        }
    });
    var newCalcuJson = calcuJson.map(function (item) {
        return {
            confidence: item.confidence,
            extractId: item.extractId,
            infoText: item.infoText,
            key: item.key,
            pageNum: item.pageNum,
            // showType: listJson.some((listItem) => listItem.select === item.extractId) ? "selected" : "hidden",
            shapeId: item.shapeId,
            type: item.type,
            wordsLocation: item.wordsLocation,
        };
    });
    return { calcuJson: newCalcuJson, listJson: listJson };
}
var constructUsefulData = function (info, seq, isLlm) {
    var calcuJson = [];
    var listJson = [];
    var _loop_2 = function (key) {
        var resultListItem = {
            key: key,
            data: [],
            drawData: [],
            value: '',
            inputType: seq.find(function (seqItem) { return seqItem.extractNum === key; })
                ? seq.find(function (seqItem) { return seqItem.extractNum === key; }).fieldType
                : '1',
            select: null,
            selectType: null,
            confidence: null,
            isLlm: isLlm,
        };
        info[key].forEach(function (infoItem, index) {
            var extractId = v4();
            if (!resultListItem.data.some(function (listJsonDataItem) { return listJsonDataItem.extractId === extractId; })) {
                resultListItem.data.push({
                    confidence: infoItem.confidence,
                    extractId: extractId,
                    infoText: infoItem.text,
                    type: 'calcuJson',
                });
            }
            if (index === 0) {
                resultListItem.confidence = infoItem.confidence;
                resultListItem.select = extractId;
                resultListItem.selectType = 'calcuJson';
                resultListItem.value = infoItem.text;
            }
            infoItem.indexNew.forEach(function (infoShapeItem) {
                var shapeId = v4();
                // if (
                //   !resultListItem.data.some(
                //     listJsonDataItem => listJsonDataItem.extractId === extractId
                //   )
                // ) {
                //   resultListItem.data.push({
                //     confidence: infoItem.confidence,
                //     extractId: extractId,
                //     infoText: infoItem.text,
                //     type: 'calcuJson',
                //   });
                // }
                calcuJson.push({
                    confidence: infoItem.confidence,
                    tableFlag: false,
                    tableId: null,
                    key: key,
                    extractId: extractId,
                    infoText: infoItem.text,
                    type: 'calcuJson',
                    pageNum: infoShapeItem.pageNum,
                    shapeId: shapeId,
                    wordsLocation: infoShapeItem.wordsLocation,
                    words: infoShapeItem.words,
                });
            });
        });
        listJson.push(resultListItem);
    };
    for (var key in info) {
        _loop_2(key);
    }
    return {
        calcuJson: calcuJson,
        listJson: listJson,
    };
};
